import * as React from 'react'

import { EmptyPageSimulations } from 'components/shared/empty-screen-page'
import ProposedSimulationCard from 'components/shared/proposed-simulation-card'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select'

type Order = 'ALPHABETIC' | 'ALPHABETIC-REVERSE' | 'TIME' | 'TIME-REVERSE'

const ProposedPage = (props: SimulationsNotebook) => {
    const [order, setOrder] = React.useState<Order>('TIME-REVERSE')

    const compareByName = (a: ExamSimulation, b: ExamSimulation) => {
        return a.name.localeCompare(b.name)
    }

    const compareByTimestamp = (a: ExamSimulation, b: ExamSimulation) => {
        return new Date(a.available_from).getTime() - new Date(b.available_from).getTime()
    }

    const sortedSims = React.useMemo(() => {
        const simulations = props.simulations?.slice()
        if (simulations) {
            if (order === 'ALPHABETIC') {
                simulations.sort(compareByName)
            } else if (order === 'ALPHABETIC-REVERSE') {
                simulations.sort((a, b) => compareByName(b, a))
            } else if (order === 'TIME') {
                simulations.sort((a, b) => compareByTimestamp(b, a))
            } else if (order === 'TIME-REVERSE') {
                simulations.sort((a, b) => compareByTimestamp(a, b))
            }
        }

        return simulations
    }, [props.simulations, order])

    return props.simulations && props.simulations.length > 0 ? (
        <div className="mt-6">
            <div>
                <Select value={order} onValueChange={(val) => setOrder(val as Order)}>
                    <SelectTrigger className="w-[180px] mb-3">
                        <SelectValue placeholder="Scegli l'ordine." />
                    </SelectTrigger>
                    <SelectContent className="z-50 px-4">
                        <SelectGroup className="flex flex-col w-full gap-6 items-center justify-start">
                            <SelectItem className="cursor-pointer" value={'ALPHABETIC'}>
                                Alfabetico - CRE
                            </SelectItem>
                            <SelectItem value={'ALFABETIC-REVERSE'}>Alfabetico - DEC</SelectItem>
                            <SelectItem value={'TIME-REVERSE'}>Temporale - DEC</SelectItem>
                            <SelectItem value={'TIME'}>Temporale - CRE </SelectItem>
                        </SelectGroup>
                    </SelectContent>
                </Select>
            </div>
            <div className="w-full  grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
                {sortedSims?.map((simulationProposal) => (
                    <div className="w-full" key={'page_prop' + simulationProposal._id}>
                        <ProposedSimulationCard testid="proposed" simulation={simulationProposal} />
                    </div>
                ))}
            </div>
        </div>
    ) : (
        <EmptyPageSimulations
            title="Non ci sono ancora simulazioni proposte"
            description="La tua scuola non ha ancora caricato delle simulazioni proposte, ritorna tra un po’ di tempo"
        />
    )
}

export default ProposedPage
